import {
  ExportInterfaceConfigurationDetailsFTPClientDTO,
  ExportInterfaceConfigurationFTPClientType, ExportInterfaceConfigurationFTPTestResultDTO, MediaStorageType,
} from '../../../../../base/models/models.swagger.generated';
import { Component, OnInit, ViewChild } from '@angular/core';
import { UntypedFormGroup, Validators, ReactiveFormsModule } from '@angular/forms';
import { ConfigurationFormCoordinatorService } from '../configuration-form-coordinator.service';
import { FileInfo, SelectedEventArgs, Uploader, UploaderModule } from '@syncfusion/ej2-angular-inputs';
import { ExportConfigurationService } from '../../../export-configuration.service';
import { DialogComponent, DialogModule } from '@syncfusion/ej2-angular-popups';
import { TranslateModule } from '@ngx-translate/core';

import { YesNoGroupButtonComponent } from '../../../../../base/shared/yes-no-group-button/yes-no-group-button.component';
import { PasswordVisibilityDirective } from '../../../../../directives/password-visibility.directive';
import { EnumDropDownListComponent } from '../../../../../base/shared/enum-drop-down-list/enum-drop-down-list.component';
import { AppErrorMessagesComponent } from '../../../../../base/error-messages/app-error-messages.component';

@Component({
    selector: 'app-configuration-form-ftp',
    templateUrl: './configuration-form-ftp.component.html',
    styleUrls: ['./configuration-form-ftp.component.scss'],
    imports: [ReactiveFormsModule,
              AppErrorMessagesComponent,
              EnumDropDownListComponent,
              PasswordVisibilityDirective,
              YesNoGroupButtonComponent,
              UploaderModule,
              DialogModule,
              TranslateModule
    ]
})
export class ConfigurationFormFtpComponent implements OnInit {
  @ViewChild('defaultupload') public defaultupload: Uploader;
  @ViewChild('dialog') public dialog: DialogComponent;

  public FTPClientType = ExportInterfaceConfigurationFTPClientType;

  public get configurationFormFTP(): UntypedFormGroup {
    return this.configurationFormService.configurationFormFTP;
  }

  public get ftpAccess(): ExportInterfaceConfigurationFTPTestResultDTO {
    return this.configurationFormService.ftpAccess;
  }

  public formattedLog = '';

  public isTestingConnection = false;
  public get getErrorMessage(): string {
    return this.ftpAccess?.logEntries[this.ftpAccess?.logEntries.length - 1];
  }

  constructor(
    private configurationFormService: ConfigurationFormCoordinatorService,
    private exportConfigurationService: ExportConfigurationService,
  ) {
  }

  public ngOnInit(): void {
    this.configurationFormFTP?.get('useCertificate').valueChanges.subscribe( value => {
      if(!value) {
        this.onFileRemove();
        this.configurationFormFTP.get('certificateMediaName').clearValidators();
        this.configurationFormFTP.get('password').setValidators([Validators.required]);
      } else {
        this.configurationFormFTP.get('certificateMediaName').setValidators([Validators.required]);
        this.configurationFormFTP.get('certificateMediaName').markAsTouched();
        this.configurationFormFTP.get('password').clearValidators();
      }
      this.configurationFormFTP.get('certificateMediaName').updateValueAndValidity();
      this.configurationFormFTP.get('password').updateValueAndValidity();
    })

    if(this.configurationFormFTP?.get('useCertificate').value == true) {
      this.configurationFormFTP.get('certificateMediaName').setValidators([Validators.required]);
      this.configurationFormFTP.get('certificateMediaName').updateValueAndValidity();
      this.configurationFormFTP.get('password').clearValidators();
      this.configurationFormFTP.get('password').updateValueAndValidity();
    }
  }

  public onFileRemove() {
    this.configurationFormFTP.get('certificateMediaId').setValue(null);
    this.configurationFormFTP.get('certificateMediaName').setValue(null);
    this.configurationFormFTP.get('certificateContentBase64').setValue(null);
    this.configurationFormFTP.get('certificateMediaType').setValue(null);
    this.configurationFormFTP.get('certificatePassword').setValue(null);
    this.defaultupload?.clearAll();
    this.configurationFormFTP.get('password').setValidators([Validators.required]);
    this.configurationFormFTP.get('password').updateValueAndValidity();
  }

  public onFileSelected($event: SelectedEventArgs) {
    const files: FileInfo[] = $event.filesData;
    this.handleFileInput(files);
  }

  public testFtpAccess() {
    this.isTestingConnection = true;
    const rawValue = this.configurationFormFTP.getRawValue() as ExportInterfaceConfigurationDetailsFTPClientDTO;
    const configurationId = this.configurationFormService.configurationDetailsDTO?.id;
    this.exportConfigurationService.testFtpAccess(configurationId, rawValue).subscribe(data => {
      this.configurationFormService.ftpAccess = data;
      this.isTestingConnection = false;
      this.formattedLog = data.logEntries.join('\n');
    });
  }

  public showLog(): void {
    this.dialog.show();
  }

  public closeLog(): void {
    this.dialog.hide();
  }

  private handleFileInput(files: FileInfo[]) {
    if (!files || files.length < 1) {
      return;
    }
    const file = files[0];
    const reader = new FileReader();
    reader.onload = (event) => {
      let base64Data = event.target.result as string;
      const startIndex = base64Data.search(';base64,');
      if (startIndex > 0) {
        // replace type by cert
        base64Data = 'data:application/' + file.type.toLowerCase() + base64Data.substring(startIndex);
      } else {
        base64Data = 'data:application/' + file.type.toLowerCase() + ';base64,' + base64Data;
      }
      this.configurationFormFTP.get('certificateContentBase64').setValue(base64Data);
    };
    reader.readAsDataURL(file.rawFile as File);
    this.configurationFormFTP.get('certificateMediaName').setValue(file.name);
    this.configurationFormFTP.get('certificateMediaName').updateValueAndValidity();
    const mediaType = this.mapFileTypeToMediaType(file.type);
    this.configurationFormFTP.get('certificateMediaType').setValue(mediaType);
    this.configurationFormFTP.get('certificateMediaId').setValue(null);
    this.configurationFormFTP.get('password').clearValidators();
    this.configurationFormFTP.get('password').updateValueAndValidity();
  }

  private mapFileTypeToMediaType(fileType: string): MediaStorageType {
    if (!fileType) {
      return null;
    }
    const type = fileType.toLowerCase();
    for (const enumMember in MediaStorageType) {
      if (typeof(enumMember) === 'string' && enumMember.toLowerCase() === type) {
        return +MediaStorageType[enumMember];
      }
    }
    return null;
  }
}
